import React, { FC } from 'react'

import { WordbookFragmentFragment } from '@Generated/graphql'
import { Trans } from '@Globals/Translations'

export interface WordbookProps {
  components?: readonly React.ReactElement[] | { readonly [tagName: string]: React.ReactElement }
  fallback?: string
  wordbook?: WordbookFragmentFragment | null
}

export const Wordbook: FC<WordbookProps> = ({ components, fallback, wordbook }) => {
  if (!wordbook && fallback) {
    return fallback
  }
  if (!wordbook) {
    return null
  }
  return (
    <Trans
      components={components}
      id={wordbook.id}
      value={wordbook.value}
      values={wordbook.values || undefined}
    >
      {wordbook.value || wordbook.defaults}
    </Trans>
  )
}

